import React, { type ReactNode } from 'react'
import * as Styled from './empty-block.styled'
import { Button } from 'ui/button/ui-button'

interface EmptyBlockProps {
  title: string
  text: ReactNode
  buttonText?: string
  onClick?: () => void
  link?: string
}

const EmptyBlock: React.FC<EmptyBlockProps> = ({ title, text, buttonText, onClick, link }) => {
  return (
    <Styled.Wrap>
      <h4>{title}</h4>
      <p>{text}</p>
      {buttonText &&
        <Button
          onClick={onClick}
          to={link}
          format='blue'
        >
          {buttonText}
        </Button>
      }
    </Styled.Wrap>
  )
}

export default EmptyBlock
